import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const Lines = styled.div`
	border: 1px solid ${({ color }) => (color ? color : CONFIG.colors.grey)};
	margin-bottom: 15px;
	margin-top: 15px;
	transform: rotate(180deg);
	width: 100%;
`;
